@if (!loading) {
  <div>
    <div class="page-container page-wrapper" [style.background-image]="backgroundImageUrl()">
      <div class="welcome-container">
        <div class="card">
          <div class="card-header">{{'Welcome' | translate}}</div>
          <div class="card-body">
            <div class="alert alert-info mb-3">
              <div class="d-flex align-items-center">
                <div>
                  <p class="mb-1">
                    <i class="bi bi-info-circle-fill text-info me-2"></i>
                    {{'SB_Hello' | translate}}, {{ userName || "dear user" }}
                  </p>
                  <p class="mb-0">
                    <i class="bi bi-info-circle-fill text-info me-2"></i>
                    {{'SB_Welcome_in_order_to_continue_you_need_to_supply_a_new_password' | translate}}
                  </p>
                </div>
              </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="mb-3">
                <label for="email" class="form-label">{{'SB_Email_Address' | translate}}</label>
                <input type="email" id="email" formControlName="email" class="form-control" autocomplete="email" readonly/>
                @if (form.get('email')?.invalid && form.get('email')?.touched) {
                  <div class="text-danger">
                    {{'SB_This_field_is_required' | translate}}
                  </div>
                }
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">{{'SB_Set_New_Password' | translate}}</label>
                <input
                  type="password"
                  id="password"
                  formControlName="password"
                  class="form-control"
                  autocomplete="new-password"
                  />
                  <p class="text-muted">
                    {{'SB_Passwords_must_include_the_elements_below_to_help_ensure_data_security' | translate}}
                  </p>
                  <div class="validators">
                    <p
                      [class.text-danger]="hasPasswordError('minlength') || form.get('password')?.value === ''"
                      [class.text-success]="!hasPasswordError('minlength') && form.get('password')?.value !== ''"
                      >
                      <span class="glyphicon" [ngClass]="hasPasswordError('minlength') || form.get('password')?.value === '' ? 'glyphicon-exclamation-sign' : 'glyphicon-ok-sign'"></span>
                      <i
                        class="bi"
                        [class.bi-x-circle-fill]="hasPasswordError('minlength') || form.get('password')?.value === ''"
                        [class.bi-check-circle-fill]="!hasPasswordError('minlength') && form.get('password')?.value !== ''"
                      ></i>
                      {{'SB_Password_Requirement_Length' | translate}}
                    </p>
                    <p
                      [class.text-danger]="hasPasswordError('uppercase')"
                      [class.text-success]="!hasPasswordError('uppercase')"
                      >
                      <span class="glyphicon" [ngClass]="hasPasswordError('uppercase') ? 'glyphicon-exclamation-sign' : 'glyphicon-ok-sign'"></span>
                      <i
                        class="bi"
                        [class.bi-x-circle-fill]="hasPasswordError('uppercase')"
                        [class.bi-check-circle-fill]="!hasPasswordError('uppercase')"
                      ></i>
                      {{'SB_Password_Requirement_Uppercase' | translate}}
                    </p>
                    <p
                      [class.text-danger]="hasPasswordError('lowercase')"
                      [class.text-success]="!hasPasswordError('lowercase')"
                      >
                      <span class="glyphicon" [ngClass]="hasPasswordError('lowercase') ? 'glyphicon-exclamation-sign' : 'glyphicon-ok-sign'"></span>
                      <i
                        class="bi"
                        [class.bi-x-circle-fill]="hasPasswordError('lowercase')"
                        [class.bi-check-circle-fill]="!hasPasswordError('lowercase')"
                      ></i>
                      {{'SB_Password_Requirement_Lowercase' | translate}}
                    </p>
                    <p [class.text-danger]="hasPasswordError('digit')"
                      [class.text-success]="!hasPasswordError('digit')">
                      <span class="glyphicon" [ngClass]="hasPasswordError('digit') ? 'glyphicon-exclamation-sign' : 'glyphicon-ok-sign'"></span>
                      <i
                        class="bi"
                        [class.bi-x-circle-fill]="hasPasswordError('digit')"
                        [class.bi-check-circle-fill]="!hasPasswordError('digit')"
                      ></i>
                      {{'SB_Password_Requirement_Digit' | translate}}
                    </p>
                    <p
                      [class.text-danger]="hasPasswordError('specialChar')"
                      [class.text-success]="!hasPasswordError('specialChar')"
                      >
                      <span class="glyphicon" [ngClass]="hasPasswordError('specialChar') ? 'glyphicon-exclamation-sign' : 'glyphicon-ok-sign'"></span>
                      <i
                        class="bi"
                        [class.bi-x-circle-fill]="hasPasswordError('specialChar')"
                        [class.bi-check-circle-fill]="!hasPasswordError('specialChar')"
                      ></i>
                      {{'SB_Password_Requirement_Special' | translate}}
                    </p>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="confirmPassword" class="form-label">{{'SB_Confirm_New_Password' | translate}}</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    class="form-control"
                    autocomplete="new-password"
                    />
                    @if (form.get('confirmPassword')?.touched) {
                      <div>
                        @if (form.get('confirmPassword')?.errors?.['required']) {
                          <p class="text-danger">
                            {{'SB_Register_Confirm_Password_Required' | translate}}
                          </p>
                        }
                        @if (form.errors?.['passwordsMismatch']) {
                          <p class="text-danger">{{'SB_Register_Password_Mismatch' | translate}}</p>
                        }
                      </div>
                    }
                  </div>
                  <button type="submit" class="btn btn-primary" [disabled]="form.invalid">{{'SB_Account_Continue' | translate}}</button>
                </form>
              </div>
            </div>
            <div class="language-button-container">
              @if (languageItems?.length > 0) {
                <sb-button
                  [dropdownItems]="languageItems"
                  [message]="selectedLanguage?.languageCode"
                  [isMessageTranslated]="false"
                  [messageXs]="' '"
                  [imgUrl]="selectedLanguage?.imgUrl"
                  buttonClass="link"
                  customClasses="language-button"
                  dropdownClasses="dropdown-sm-fullscreen"
                  [tooltipText]="'SB_Languages'"
                  tooltipPlacement="bottom"
                  (onClick)="onButtonClick($event)">
                </sb-button>
              }
            </div>
          </div>
          <footer class="footer bg-dark text-light py-2 mt-auto">
            <p class="small text-center mb-1">
              <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
                &copy; {{ currentYear }} - EveryBuddy Ltd
              </a>
            </p>
            <p class="small text-center mb-0">
              <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
                {{'SB_About' | translate}}
              </a>
            </p>
          </footer>
        </div>
      </div>
    }

